import { useQuery } from '@tanstack/react-query';
import { getImageUrlsByTags } from '@/services/cloudinary';

const MAX_RESULTS = 1;

interface GetImageUrlsByTagsProperties {
  maxResults?: number;
  tags: string | null;
}

export default function useGetImageUrlsByTags({
  maxResults = MAX_RESULTS,
  tags,
}: GetImageUrlsByTagsProperties) {
  const queryKey = ['get_image_urls_by_tags', maxResults, tags];

  return useQuery({
    enabled: tags !== null,
    queryFn: () => getImageUrlsByTags({ maxResults, tags: tags ?? '' }),
    queryKey,
    select: data => data.resources,
  });
}
